import HomePage from './homePage';

export default HomePage;